export const SESSION_SUCCESS = 'Your login url is being emailed to you.'
export const SESSION_FAILURE = 'Email not found. Create a new request.'
export const SESSION_BAD_TOKEN = 'Bad Login Token. Please enter your email to generate a new login token.'
export const SESSION_LOGGED_OUT = 'You have been logged out.'

export const SITE_TYPES = {
  rv: 'RV',
  other: 'Other',
  group: 'Group',
  tent: 'Tent',
  tentWalkIn: 'Tent (Walk In)'
}

export const AVAILABILITY_REQUEST = {
  errors: {
    dupe:
      'Request is a duplicate of an existing active reqest. Please review to see if that active request is enough. Reach out to us if you are having trouble creating a request that matches your needs.'
  }
}
